module.exports = __webpack_public_path__ + "img/08.4065f81b.webp";